import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { checkLectureWatchtime } from '../../../../Utilities/api';
import { AdminRoutesContext } from '../AdminRoutesContext';
export const useCheckLectureWatchtime = ({ courseUuid, lectureUuid }) => {
    const { isPreviewMode } = useContext(AdminRoutesContext);
    return useQuery({
        queryKey: ['lectureWatchtime', courseUuid, lectureUuid],
        queryFn: () => checkLectureWatchtime(courseUuid, lectureUuid),
        refetchInterval: isPreviewMode ? false : 5000,
        staleTime: 3000,
        enabled: !isPreviewMode,
    });
};
